import { PointoramaSurface } from '../../../../utils/PointoramaSurface';
import { Viewer } from '../../../../viewer/viewer';

/**
 * Query InputHandler for any hovered selectable object (measure, plane, surface, or box).
 * Returns the hovered object, or null/undefined if nothing is hovered.
 */
export function getHoveredSelectable(viewer: Viewer): unknown {
  const ih = viewer.inputHandler;
  return ih.getHoveredMeasure() || ih.getHoveredPlane() || ih.getHoveredSurface() || ih.getHoveredBox();
}

/**
 * Dispatch the appropriate selection event on viewer.scene.
 *
 * - Surfaces dispatch `select_group` with the surface identifier.
 * - Everything else (measures, planes, boxes) dispatches `measurement_select`.
 */
export function dispatchSelection(viewer: Viewer, ctrlDown: boolean): void {
  const ih = viewer.inputHandler;

  // Surfaces are groups, not annotations — dispatch select_group
  const hoveredSurface = ih.getHoveredSurface() as PointoramaSurface | null;
  if (hoveredSurface) {
    viewer.scene.dispatchEvent({
      type: 'select_group',
      value: { groupIdentifier: hoveredSurface.identifier },
    });
    return;
  }

  // Everything else dispatches measurement_select
  const measure = ih.getHoveredMeasure() || ih.getHoveredPlane() || ih.getHoveredBox();
  viewer.scene.dispatchEvent({
    type: 'measurement_select',
    value: { measure, isCtrl: ctrlDown },
  });
}
